//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ListingWindow.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleA",1,0],[0,"AngleB",1,0],[0,"AngleString",1,0],[0,"CollisionAvoidanceEnum",1,0],[1,"ComponentSelection",0,"SelectNXObjectList",0],[0,"CreatePathsEnum",1,0],[0,"IncludeSubComponents",1,0],[0,"PathOrderEnum",1,0],[0,"PointOrderEnum",1,0],[0,"ProbeTipType",1,0],[0,"ProgramLocationString",1,0],[0,"ScopeEnum",1,0],[0,"TipString",1,0],[0,"ToolString",1,0],[0,"ViewString",1,0],[0,"WorkpieceString",1,0]],[[[],"SafePlaneSelectAction",{},0,0],[[],"SafePlaneDisplayAction",{},0,0],[[],"LinkToPmi",{},0,0],[["nResults"],"GetResults",{R_:{results:""}},0,0],[["device_type","file_name"],"OutputResults",{},2,0]],[]];
SPLM.CAM.InspectionLinkPmiBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionLinkPmiBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionLinkPmiBuilder.PmiScopeTypes = Object.freeze({
    "WorkpieceOnly" : "WorkpieceOnly", "WorkpieceandComponents" : "WorkpieceandComponents"});

SPLM.CAM.InspectionLinkPmiBuilder.CreatePathsOptions = Object.freeze({
    "Yes" : "Yes", "No" : "No"});

SPLM.CAM.InspectionLinkPmiBuilder.PointOrderTypes = Object.freeze({
    "Off" : "Off", "NearestNeighbor" : "NearestNeighbor", "ShortestPath" : "ShortestPath"});

SPLM.CAM.InspectionLinkPmiBuilder.PathOrderTypes = Object.freeze({
    "Off" : "Off", "BySensor" : "BySensor", "NearestNeighbor" : "NearestNeighbor", "ShortestPath" : "ShortestPath"});

SPLM.CAM.InspectionLinkPmiBuilder.CollisionAvoidanceEnumType = Object.freeze({
    "Off" : "Off", "On" : "On"});

export default SPLM;